/* eslint-disable react/no-array-index-key */
import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { useContextCurrentSite } from 'contexts';
import { useContextProperties } from 'contexts/properties';
import { useContextMatchParams } from 'contexts/matchParams';
import { useContextResultOrigin } from 'contexts/resultOrigin';

import LoadingPlaceholder from 'components/loadingPlaceholder';
import usePlacesProvider from 'dataProvider/hooks/usePlacesProvider';
import BreadCrumb from 'components/breadcrumb';
import BarSeats from 'components/barsSeats';
import useDebounce from 'dataProvider/hooks/useDebounce';
import { Button } from 'components';

import CustomMap from '../../components/homeMap/customMap';
import Tag from '../../components/tag';
import Tags from '../../components/tags';
import Autocomplete from '../../components/autocomplete';

import { getSite, LOCALHOST } from '../../constants/sites';

/**
 * Componente que va a pintar el Home principal de las elecciones municipales
 *
 *
 */
const MainMultiplyMunicipal = ({
  mapData,
  onChangeLocation,
  partiesWinners
}) => {
  const { params } = useContextProperties();
  const resultOrigin = useContextResultOrigin();

  const { matchParams } = useContextMatchParams();
  const { electionNumber, subtype, placesId, type, year } = matchParams;

  const placesIdList = placesId.split('-');

  const [rows, setRows] = useState([]);
  const [autocomplePro, setAutocomplePro] = useState('');
  const [autocompleMun, setAutocompleMun] = useState('');

  const site = getSite();

  const { currentSite } = useContextCurrentSite();

  useEffect(() => {
    if (params) {
      const rowsData =
        params.sites[site === LOCALHOST ? currentSite : site].views[
          type.toLocaleLowerCase()
        ].homeMultiTowns.rows;

      setRows(rowsData);
    }
  }, [params, site, currentSite, type]);

  const { result: dataPlacesProvince } = usePlacesProvider({
    type: 'PROVINCE',
    sortby: 'name',
    electionType: type
  });
  const debouncedSearch = useDebounce(autocompleMun, 400);
  const { result: dataPlacesTown } = usePlacesProvider({
    sortby: 'name',
    name: debouncedSearch,
    type: 'TOWN',
    size: 10,
    electionType: type
  });
  const { result: dataPlacesTownPrincipals } = usePlacesProvider({
    sortby: 'main',
    type: 'TOWN',
    size: 10,
    electionType: type
  });

  // esto se hace para que la capital de provincia se vea en el mapa
  const dataBreadcrumb = [
    {
      name: 'Municipales',
      ineId: 'C108'
    }
    // selectedPlace
  ];

  if (
    !rows ||
    !dataPlacesTownPrincipals ||
    !dataPlacesTown ||
    !dataPlacesProvince
  ) {
    return <LoadingPlaceholder />;
  }
  const textPactButton =
    params?.sites[site === LOCALHOST ? currentSite : site].labels
      .pactometro_url || '#';

  const content = rows.map((row, index) => (
    <div className={row.class} key={`row-${index}`}>
      {row.columns.map((column, index2) => (
        <div className={column.class} key={`col-${index2}`}>
          {column.components.map(item => (
            <div className={item.class || ''} key={item.module}>
              {/* PlacesProvider REGION PROVINCE TOWN */}
              {item.module === 'SELECTORS' && (
                <Fragment>
                  <div className="row-places">
                    {
                      <>
                        {/* PlacesProvider PROVINCE */}
                        {dataPlacesProvince && (
                          <div className="col-places">
                            <Autocomplete
                              results={dataPlacesProvince.filter(d =>
                                autocomplePro
                                  ? d.name
                                      .toLocaleLowerCase()
                                      .includes(
                                        autocomplePro.toLocaleLowerCase()
                                      )
                                  : d
                              )}
                              onChange={value => setAutocomplePro(value)}
                              onSelect={(event, select) => {
                                onChangeLocation(event, select);
                                setAutocomplePro('');
                              }}
                              placeholder="Buscar provincia"
                              showArrow
                              type={type}
                              params={params}
                              year={year}
                            />
                          </div>
                        )}
                        {/* PlacesProvider TOWN */}
                        {dataPlacesTown && (
                          <div className="col-places">
                            <Autocomplete
                              results={dataPlacesTown}
                              onChange={value => setAutocompleMun(value)}
                              onSelect={(event, select) => {
                                onChangeLocation(event, select);

                                setAutocompleMun('');
                              }}
                              placeholder="Buscar municipio"
                              showArrow
                              type={type}
                              params={params}
                              year={year}
                            />
                          </div>
                        )}
                      </>
                    }
                  </div>
                  <BreadCrumb dataBreadcrumb={dataBreadcrumb} />
                </Fragment>
              )}
              {/* ResultProvider OLDATA historic */}
              {item.module === 'MAP' && (
                <CustomMap
                  currentCommunity=""
                  electionNumber={electionNumber}
                  maps={mapData}
                  native
                  onChange={(event, _item) =>
                    onChangeLocation(event, _item, true)
                  }
                  partiesWinners={partiesWinners}
                  selectedPlace=""
                  showDots
                  showTooltipInfo
                  type={type}
                  year={year}
                />
              )}
              {/* PlacesProvider TOWN */}
              {item.module === 'TAGS' && (
                <Fragment>
                  <h3 className="tags-title">
                    Resultado de las elecciones en:
                  </h3>
                  <div className="tags_container">
                    <Tags>
                      {dataPlacesTownPrincipals?.map(d => (
                        <Tag
                          key={`${d.ineId}-${d.name}`}
                          onClick={e => {
                            onChangeLocation(e, d);
                          }}
                          native
                          route={d.path}
                        >
                          {d.name}
                        </Tag>
                      ))}
                    </Tags>
                  </div>
                </Fragment>
              )}
              {item.module === 'BARINFO' &&
                placesIdList.map(place => (
                  <BarSeats
                    key={place}
                    place={place}
                    resultOrigin={resultOrigin}
                    year={year}
                    type={type}
                    elSubtype={subtype}
                    electionNumber={electionNumber}
                    site={site}
                  />
                ))}
              {item.module === 'BTN_PACTOMETER' && (
                <Button className="button--primary" link url={textPactButton}>
                  Pactómetro Elecciones 28M
                </Button>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  ));

  return <Fragment>{content}</Fragment>;
};

export default MainMultiplyMunicipal;

MainMultiplyMunicipal.propTypes = {
  mapData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onChangeLocation: PropTypes.func.isRequired,
  partiesWinners: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  resultOrigin: PropTypes.shape({}).isRequired
};
